import React from 'react';
import parse, { domToReact } from 'html-react-parser';

// Sanitized at build time. Keep headings/lists and the contact form's custom
// link renderer without introducing layout-changing wrapper elements.
export function CmsRichText({ field, fallback = null, components = {} }) {
  if (!field?.html) return fallback;
  const options = {
    replace(node) {
      if (node.type === 'tag' && node.name === 'a' && components.hyperlink) {
        const Hyperlink = components.hyperlink;
        return (
          <Hyperlink node={{ data: { url: node.attribs.href } }}>
            {domToReact(node.children, options)}
          </Hyperlink>
        );
      }
      return undefined;
    },
  };
  return <>{parse(field.html, options)}</>;
}

export function CmsText({ field }) {
  return <>{typeof field === 'string' ? field : field?.text || ''}</>;
}
